import { initKeycloak } from "./authorization/keycloak/keycloak";
import { parmAutoProvision, parmUserPermissions } from "./authorization/parm/parm";
import { initSingleSpa } from "./singleSpa";
import { createKeycloakInterface } from "./authorization/authorizationInterface";
import { createSmartAuthInterface, getSmartSessionId } from "./authorization/smart/smart";
import { setAuthorizationInterface } from "./static/authorization";
import { ParmConstants } from "./types/parm";

export const startApp = async () => {
  console.log(`GUAC-CORE VERSION: ${process.env.npm_package_version}`); //eslint-disable-line

  const sessionId = getSmartSessionId();
  let authInterface = null;

  if (sessionId) {
    authInterface = await createSmartAuthInterface(sessionId);
  } else {
    const keycloak = await initKeycloak();
    authInterface = createKeycloakInterface(keycloak);
  }

  setAuthorizationInterface(authInterface);

  await parmAutoProvision();
  await parmUserPermissions();

  if (window.location.pathname === "/logout") {
    window.history.pushState({}, "", "/");
    authInterface.logout();
    return;
  }

  await initSingleSpa();
};
